import ReactDOM from 'react-dom';
import React from 'react';
import JumpableZoomableDragable from '../components/JumpableZoomableDragable';
import Urls from '../urls/Urls';
import ParameterErrors from '../errors/ParameterErrors';
import './FullScreenImagesViewer.css';
import IconButtonNonReact from './IconButtonNonReact';
const {throwNotProvided}=ParameterErrors;
export default class FullScreenImagesViewer {
	constructor({configuration}){
		this._configuration = configuration;
		this._element = document.createElement('div');
		this._element.classList.add("full-screen-images-viewer");
		this._jumpableZoomableDragableWrapperElement = document.createElement('div');
		this._jumpableZoomableDragableWrapperElement.classList.add('jumpable-zoomable-dragable-wrapper');
		this._jumpableZoomableDragableFactory= React.createFactory(JumpableZoomableDragable);
		this.hide= this.hide.bind(this);
		this.show= this.show.bind(this);
		this._setVisible= this._setVisible.bind(this);
		this._renderJumpableZoomableDragable= this._renderJumpableZoomableDragable.bind(this);
		this._handleClickButtonClose= this._handleClickButtonClose.bind(this);
		this._renderJumpableZoomableDragable([]);
		this._iconButtonNonReactClose = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Exit.png',
			onClick:this._handleClickButtonClose});
		this._element.appendChild(this._jumpableZoomableDragableWrapperElement);
		this._element.appendChild(this._iconButtonNonReactClose.element);
	}
	_handleClickButtonClose(){
		this.hide();
	}
	_renderJumpableZoomableDragable(images){
		ReactDOM.render(this._jumpableZoomableDragableFactory(
			{ 
				images:images,
				rootUrl:Urls.getAssetsForSite(this._configuration.siteSlug),
				zoomMin:1,
				zoomMax:4
			}),
			this._jumpableZoomableDragableWrapperElement);
	}
	get element(){
		return this._element;
	}
	hide(){
		this._setVisible(false);
	}
	show({images}){
		this._setVisible(true);
		this._renderJumpableZoomableDragable(images);
	}
	_setVisible(value){
		if(value){
			document.body.classList.add('full-screen-images-viewer-visible');
			this._element.classList.add('visible');
		}
		else {
			document.body.classList.remove('full-screen-images-viewer-visible');
			this._element.classList.remove('visible');
		}
	}
}
